import { render, staticRenderFns } from "./korean_radio_cateList.vue?vue&type=template&id=3a1e472a&scoped=true"
import script from "./korean_radio_cateList.vue?vue&type=script&lang=js"
export * from "./korean_radio_cateList.vue?vue&type=script&lang=js"
import style0 from "./korean_radio_cateList.vue?vue&type=style&index=0&id=3a1e472a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1e472a",
  null
  
)

export default component.exports